<template>
  <div>
    <!-- Exibindo dados atuais -->
    <div v-if="state == 1" class="pa-6">
      <div v-if="value.vehicle != null">
        Esta câmera está atualmente instalada no veículo
        <code>{{ value.vehicle.code }}</code> da organização
        <code>{{ value.vehicle.org.label }}</code
        >.
        <br />
        <v-btn large color="primary" class="mt-6" @click="state = 4">
          Iniciar Retirada...
        </v-btn>
      </div>
      <div v-else>
        Esta câmera não está instalada em nenhum veículo.
        <br />
        <v-btn large color="primary" class="mt-6" @click="state = 2">
          Iniciar Associação...
        </v-btn>
      </div>
    </div>

    <!-- Início de associação -->
    <div v-if="state == 2">
      <p class="text-body-1 px-6 pt-6">
        Selecione o veículo onde a câmera será instalada:
      </p>

      <v-text-field
        class="ma-6"
        v-model="keywords"
        placeholder="Filtrar..."
        single-line
        hide-details
      />

      <OSelectList2 :rows="filteredVehicles" @click="selectVehicle">
        <template v-slot:default="{ row }">
          <v-list-item-title>
            <span class="mr-6" v-if="row.clientId != null">{{
              row.clientId
            }}</span>
            <span class="mr-6">{{ row.code }}</span>
            <span class="mr-6" v-if="row.extraCode != null">{{
              row.extraCode
            }}</span>
            <span class="mr-6">{{ row.org.name }}</span>
          </v-list-item-title>
          <v-list-item-subtitle>
            <OTagList
              class="small"
              style="opacity: 0.7; flex-flow: row nowrap"
              :value="row.tags"
            />
          </v-list-item-subtitle>
        </template>
      </OSelectList2>
    </div>

    <!-- Confirmando associação -->
    <div v-if="state == 3" class="pa-6">
      <p class="text-body-1">
        Confirma a instalação da câmera
        <code>{{ value.imei }}</code>
        <code v-if="value.name != null && value.name.length"
          >({{ value.name }})</code
        >
        no veículo <code>{{ selectedVehicle.code }}</code> da organização
        <code>{{ selectedVehicle.org.label }}</code
        >?
      </p>
      <div>
        <v-btn large class="mr-6" @click="state = 1">Não, cancelar</v-btn>
        <v-btn large color="primary" @click="doAssoc">Sim, associar</v-btn>
      </div>
    </div>

    <!-- Confirmando desassociação -->
    <div v-if="state == 4" class="pa-6">
      <p class="text-body-1">
        Confirma a retirada da câmera
        <code>{{ value.imei }}</code>
        <code v-if="value.name != null && value.name.length"
          >({{ value.name }})</code
        >
        do veículo <code>{{ value.vehicle.code }}</code> da organização
        <code>{{ value.vehicle.org.label }}</code
        >?
      </p>
      <div>
        <v-btn large class="mr-6" @click="state = 1">Não, cancelar</v-btn>
        <v-btn large color="primary" @click="doDisassoc">Sim, retirar</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import EditStore from './EditStore'
import OSelectList2 from 'oderon-vue/cpts/OSelectList2.vue'
import { InstalledBase } from '@/models'
import { Camera } from './cameras-fetcher'
import utils from 'oderon-commons/src/utils.js'

export default {
  tabTitle: 'Desativar',
  components: { OSelectList2 },
  data() {
    return {
      currentVehicle: null,
      selectedVehicle: null,
      keywords: null,
      allVehicles: [],
      state: 1
    }
  },
  computed: {
    value() {
      return EditStore.row
    },
    filteredVehicles() {
      const filtered = this.allVehicles.filter((x) => {
        return utils.matchAnyLike(
          this.keywords,
          x.code,
          x.extraCode,
          (x.clientId || '').toString()
        )
      })

      return filtered.slice(0, 6)
    }
  },
  async mounted() {
    let { rows } = await InstalledBase.findAll()
    rows = rows.filter((x) => x.vehicle != null && x.vehicle.org.id != -1)
    rows = utils.orderBy(rows, 'code asc')
    this.allVehicles = rows.map((x) => {
      return {
        id: x.vehicle.id,
        clientId: x.vehicle.clientId,
        code: x.vehicle.code,
        org: x.vehicle.org,
        tags: x.vehicle.tags
      }
    })
  },
  methods: {
    async doDeactivate() {
      await EditStore.deactivate()
      this.$snack('Desativado com sucesso')
    },

    async selectVehicle(row) {
      this.selectedVehicle = row
      this.state = 3
    },

    async doAssoc() {
      await this.$loading(async () => {
        const vehicleId = this.selectedVehicle.id
        await Camera.associate(this.value.id, { vehicleId })
        await EditStore.reload()
        this.$snack('Associado com sucesso')
        this.state = 1
      })
    },

    async doDisassoc() {
      await this.$loading(async () => {
        await Camera.dissociate(this.value.id)
        await EditStore.reload()
        this.$snack('Desassociado com sucesso')
        this.state = 1
      })
    }
  }
}
</script>

<style></style>
